<template lang="pug">
  b-card.w-100(no-body)
    div(slot="header") {{$t('management_page.remote_policy')}}
      span.ml-2(@click="showHelpDialog('remotePolicy')")
        icon(name="question-circle")
    b-list-group
      b-list-group-item
        b-row
          b-col.d-flex.align-items-center(cols="12" md="12" lg="2") {{$t('management_page.remote_control')}}
          b-col.d-flex.align-items-center.contents(cols="12" md="12" lg="10")
            .switch.mr-2
              switches.lmm-switch(
                v-model="form.flag_function_rc",
                theme="bootstrap",
                :color="form.flag_function_rc ? 'warning' : 'default'"
              )
              span.ml-2 ({{$t('management_page.block_allow')}})
            .msg
              span {{$t('management_page.remote_control_restriction')}}
      
      b-list-group-item
        b-row
          b-col.d-flex.align-items-center(cols="12" md="12" lg="2") {{$t('function-settings03')}} <!-- {{$t('function-settings03')}} -->
          b-col.d-flex.align-items-center.contents(cols="12" md="12" lg="10")
            .switch.mr-2
              switches.lmm-switch(
                v-model="form.filetransfer",
                theme="bootstrap",
                :color="form.filetransfer ? 'warning' : 'default'"
              )
              span.ml-2 ({{$t('management_page.block_allow')}})
            .msg
              span {{$t('management_page.file_transfer_restriction')}}

      b-list-group-item
        b-row
          b-col.d-flex.align-items-center(cols="12" md="12" lg="2") {{$t('capture')}} <!-- {{$t('capture')}} -->
          b-col.d-flex.align-items-center.contents(cols="12" md="12" lg="10")
            .switch.mr-2
              switches.lmm-switch(
                v-model="form.capture",
                theme="bootstrap",
                :color="form.capture ? 'warning' : 'default'"
              )
              span.ml-2 ({{$t('management_page.block_allow')}})
            .msg
              span {{$t('management_page.screen_capture_recording_restriction')}}
      
      b-list-group-item
        b-row
          b-col.d-flex.align-items-center(cols="12" md="12" lg="2") {{$t('management_page.keyboard_mouse_lock')}}
          b-col.d-flex.align-items-center.contents(cols="12" md="12" lg="10")
            .switch.mr-2
              switches.lmm-switch(
                v-model="form.flag_control_lock",
                theme="bootstrap",
                :color="form.flag_control_lock ? 'warning' : 'default'"
              )
              span.ml-2 ({{$t('management_page.not_applied_applied')}})
            .msg
              span {{$t('management_page.keyboard_mouse_lock_settings')}}
      
      b-list-group-item
        b-row
          b-col.d-flex.align-items-center(cols="12" md="12" lg="2") {{$t('management_page.screen_block_black_screen')}}
          b-col.d-flex.align-items-center.contents(cols="12" md="12" lg="10")
            .switch.mr-2
              switches.lmm-switch(
                v-model="form.flag_blackscreen",
                theme="bootstrap",
                :color="form.flag_blackscreen ? 'warning' : 'default'"
              )
              span.ml-2 ({{$t('management_page.not_applied_applied')}})
            .msg
              span {{$t('management_page.screen_block_black_screen_settings')}}
      
      b-list-group-item
        b-row
          b-col.d-flex.align-items-center(cols="12" md="12" lg="2") {{$t('management_page.screen_saver')}}
          b-col.d-flex.align-items-center.contents(cols="12" md="12" lg="10")
            .switch.mr-2
              switches.lmm-switch(
                v-model="form.flag_screensaver",
                theme="bootstrap",
                :color="form.flag_screensaver ? 'warning' : 'default'"
              )
              span.ml-2 ({{$t('management_page.maintain_prevent')}})
            .msg
              span {{$t('management_page.screen_saver_local_settings')}}

      b-list-group-item
        b-row
          b-col.d-flex.align-items-center(cols="12" md="12" lg="2") {{$t('management_page.screen_power_saving')}}
          b-col.d-flex.align-items-center.contents(cols="12" md="12" lg="10")
            .switch.mr-2
              switches.lmm-switch(
                v-model="form.display_power_save",
                theme="bootstrap",
                :color="form.display_power_save ? 'warning' : 'default'"
              )
              span.ml-2 ({{$t('management_page.maintain_prevent')}})
            .msg
              span {{$t('management_page.screen_power_saving_local_settings')}}
      
      b-list-group-item
        b-row
          b-col.d-flex.align-items-center(cols="12" md="12" lg="2") {{$t('management_page.power_saving')}}
          b-col.d-flex.align-items-center.contents(cols="12" md="12" lg="10")
            .switch.mr-2
              switches.lmm-switch(
                v-model="form.system_power_save",
                theme="bootstrap",
                :color="form.system_power_save ? 'warning' : 'default'"
              )
              span.ml-2 ({{$t('management_page.maintain_prevent')}})
            .msg
              span {{$t('management_page.power_saving_local_settings')}}

    dialog-remote-policy(:show.sync="show.remotePolicy")
</template>

<script>
import Switches from "vue-switches"
import DialogRemotePolicy from "./dialog/dialogRemotePolicy.vue"

export default {
  props: {
    form: {
      type: Object,
      default: () => ({}),
    },
  },
  components: {
    Switches,
    DialogRemotePolicy,
  },
  watch: {
    "form.flag_function_rc"(val) {
      this.$emit("updateToggle", "flag_function_rc", val)
    },
    "form.filetransfer"(val) {
      this.$emit("updateToggle", "filetransfer", val)
    },
    "form.capture"(val) {
      this.$emit("updateToggle", "capture", val)
    },
    "form.flag_control_lock"(val) {
      this.$emit("updateToggle", "flag_control_lock", val)
    },
    "form.flag_blackscreen"(val) {
      this.$emit("updateToggle", "flag_blackscreen", val)
    },
    "form.flag_screensaver"(val) {
      this.$emit("updateToggle", "flag_screensaver", val)
    },
    "form.display_power_save"(val) {
      this.$emit("updateToggle", "display_power_save", val)
    },
    "form.system_power_save"(val) {
      this.$emit("updateToggle", "system_power_save", val)
    },
  },
  data() {
    return {
      show: {
        remotePolicy: false,
      },
    }
  },
  methods: {
    showHelpDialog(type) {
      this.show[type] = true
    },
  },
}
</script>

<style lang="scss" scoped></style>
